<template lang="pug">
    section.timeline
        ScrollTrigger(
            color='white'
            )
        .timeline__next
            span Листайте
        .timeline__curtain.show(
            ref='curtain'
            )

        .timeline__progress(
            ref='swiperProgressbar',
            :style='`--transform-progress: ${swiperProgress};`'
            )

        .timeline__slides(
            ref='swiperContainer'
            )

            .swiper-wrapper

                .swiper-slide.timeline__item.hidden(
                    v-for='(tl, slideIndex) in timeline',
                    ref='slide',
                    :key='slideIndex'
                    )

                    .pusher

                    router-link.timeline__item-info(
                        :to='`/${$attrs.category}/${$attrs.section}/${tl.id}`'
                    )

                        .timeline__item-city
                            span(v-html='tl.city')

                        .timeline__item-image-wrapper
                            img.timeline__item-image(
                                :src='require(`../assets/img/timeline/${tl.id}.jpg`)',
                                :title='tl.text'
                                )
                            .timeline__item-name-mobile(
                                v-html='tl.text'
                                )
                        .timeline__item-description(
                            v-html='tl.description'
                            )

                    .timeline__item-name(
                        v-html='tl.text'
                        )
            
            
            


</template>

<script>
import {Swiper, Navigation, Mousewheel, Keyboard} from 'swiper/js/swiper.esm.js';
Swiper.use([Navigation, Mousewheel, Keyboard]);

import sectionData from '@/assets/data/menu';

export default {
    name: 'Timeline',

    components: {
        ScrollTrigger: () => import('../components/ScrollTrigger.vue')
    },

    data() {
        return {
            timeline: sectionData[this.$attrs.category].articles.find(article => article.id === this.$attrs.section).articles,
            swiperInst: Object,
            swiperProgress: 0
        };
    },

    beforeMount() {
        this.$store.commit('setColor', sectionData[this.$attrs.category].articles.find(article => article.id === this.$attrs.section).theme);
    },

    mounted() {
        this.$store.commit('setTheme', 'black');

        this.initSwiper();
        this.handleResize();

        this.$refs.curtain.classList.remove('show');

        //if (this.$store.getters['sound/initiated'] && !this.$store.getters['sound/paused']) this.$store.dispatch('sound/pause');
    },

    methods: {
        initSwiper() {
            this.swiperInst = new Swiper(this.$refs.swiperContainer, {
                direction: 'vertical',
                init: false,
                updateOnWindowResize: true,
                mousewheel: {
                    sensitivity: 5
                },
                breakpoints: {
                    768: {
                        direction: 'horizontal',
                        slidesPerView: 'auto',
                        freeMode: true,
                        keyboard: true,
                        simulateTouch: false
                    }
                }
            });

            this.swiperInst.on('progress', e => (this.swiperProgress = e));

            this.swiperInst.on('init', () => {
                this.$refs.slide.forEach(element => {
                    element.classList.remove('hidden');
                });
            });

            this.swiperInst.init();
        },
        handleResize() {
            (function() {
                const throttle = function(type, name, obj = window) {
                    let running = false;
                    let func = function() {
                        if (running) return;
                        running = true;
                        requestAnimationFrame(function() {
                            obj.dispatchEvent(new CustomEvent(name));
                            running = false;
                        });
                    };
                    obj.addEventListener(type, func);
                };
                throttle('resize', 'optimizedResize');
            })();
            window.addEventListener('optimizedResize', () => {
                this.swiperInst.update();
            });
        }
    },

    beforeRouteLeave(to, from, next) {
        to;
        from;

        this.$refs.curtain.classList.add('show');

        setTimeout(() => {
            next();
        }, 600);
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';
@import '../../node_modules/swiper/css/swiper.min.css';

.swiper-wrapper {
    transition-duration: 0.8s !important;
}

.timeline {
    position: absolute;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh) * 100);
    overflow: hidden;
    top: 0;
    left: 0;

    &__next {
        display: none;
        @media (--viewport-tablet) {
            display: block;
            position: fixed;
            bottom: 28px;
            height: 28px;
            padding-left: var(--grid-column-mobile);
            left: 0;
            color: black;
            text-align: center;
            text-transform: uppercase;
            font-size: 11.5px;
            font-weight: bold;
        }

        span {
            line-height: 28px;
            display: block;
            &:after {
                content: '▼';
                display: inline-block;
                margin-left: 5px;
            }
        }
    }
    &__curtain {
        position: fixed;
        z-index: 50;
        pointer-events: none;
        background: var(--theme);
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        height: calc(var(--vh) * 100);
        transform: scaleX(0);
        transition: 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
        transform-origin: 0 100%;

        @media (--viewport-tablet) {
            transform: scaleY(0);
        }

        &.show {
            transform: scaleX(1);

            @media (--viewport-tablet) {
                transform: scaleY(1);
            }
        }
    }

    &__progress {
        --transform-progress: 0;
        position: absolute;
        z-index: 5;
        width: 100%;
        height: 100vh;
        height: calc(var(--vh) * 100);
        top: 0;
        left: 0;
        background-color: var(--theme);
        transform-origin: 0% 0%;
        transform: scaleX(var(--transform-progress));
        transition-duration: 0.8s !important;

        @media (--viewport-tablet) {
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
            transform: scaleX(1) scaleY(var(--transform-progress));
        }
    }

    &__slides {
        position: absolute;
        z-index: 7;
        width: 100%;
        height: 100vh;
        height: calc(var(--vh) * 100);
        top: 0;
        left: 0;
        padding-left: 44px;

        @media (--viewport-tablet) {
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }

    &__item {
        width: calc(var(--grid-column) * 12);
        padding-right: var(--grid-column);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        @media (--viewport-tablet) {
            width: 100%;
            padding-right: 0;
            flex-direction: column-reverse;
            justify-content: center;
        }

        &-name {
            opacity: 0;

            @media (--viewport-tablet) {
                display: none;
                padding-top: 3rem;
                margin-bottom: 1rem;
                font-size: 1rem;
            }

            &-mobile {
                display: inline-block;
                position: absolute;
                bottom: 5px;
                font-size: 1rem;
                left: 5px;
                color: white;

                @media (--viewport-tablet) {
                    left: var(--grid-column-mobile);
                }
                @media (--viewport-mobile-s), (--viewport-mobile-lp) {
                    font-size: 13px;
                    line-height: 1;
                }
            }
        }

        &:nth-child(2n) {
            .timeline {
                &__item {
                    &-city {
                        order: 3;
                        margin-top: -35px;

                        @media (--viewport-tablet) {
                            margin-top: -1rem;
                            order: 1;
                        }
                    }

                    &-name {
                        &-mobile {
                            bottom: unset;
                            top: 5px;

                            @media (--viewport-tablet) {
                                bottom: 5px;
                                top: unset;
                            }
                        }
                    }

                    &-image-wrapper {
                        order: 2;
                        padding-top: 32px;

                        @media (--viewport-tablet) {
                            margin-top: -1.2rem;
                            padding-top: 0px;
                            padding-bottom: 32px;
                        }
                    }

                    &-description {
                        order: 1;
                        margin-bottom: 45px;

                        @media (--viewport-tablet) {
                            order: 3;
                            margin-bottom: 2rem;
                        }
                    }
                }
            }
        }

        &:nth-child(2n + 1) {
            .timeline {
                &__item {
                    &-image-wrapper {
                        margin-top: -48px;
                        margin-bottom: 45px;
                        padding-bottom: 2rem;

                        @media (--viewport-tablet) {
                            margin-top: -1.2rem;
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }

        &-info {
            text-decoration: none;
            display: flex;
            flex-direction: column;

            @media (--viewport-tablet) {
                //margin-top: 28px;
            }
            @media (--viewport-mobile-s), (--viewport-mobile-lp) {
                //margin-top: 2.5rem;
            }
        }

        &-city {
            width: calc(var(--grid-column) * 6);
            font-family: var(--font-accent);
            font-weight: 800;
            font-size: 60px;
            line-height: 1.2;
            color: #000000;
            text-decoration: none;
            position: relative;
            z-index: 1;

            @media (--viewport-tablet) {
                font-size: 2rem;
                width: calc(var(--grid-column-mobile) * 11);
            }
            @media (--viewport-mobile-s), (--viewport-mobile-lp) {
                font-size: 1.3rem;
                margin-top: 0 !important;
            }

            span {
                display: block;
                width: 100%;
                height: 100%;
                line-height: 1 !important;
            }
        }

        &-image-wrapper {
            position: relative;
            width: calc(var(--grid-column) * 6);
            background-color: #000;

            @media (--viewport-tablet) {
                width: calc(var(--grid-column-mobile) * 12);
            }

            @media (--viewport-mobile-s), (--viewport-mobile-lp) {
                max-height: 39vh;
                padding: 0 1.5rem 1.5rem 0 !important;
                width: calc(var(--grid-column-mobile) * 10) !important;
                margin: 0 auto;
            }
            @media (--viewport-mobile-lp) {
                width: fit-content !important;
            }

            &:before {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: white;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;

                @media (--viewport-mobile-s), (--viewport-mobile-lp) {
                    max-height: 38vh;
                    width: auto;
                }
            }
        }

        &-image {
            width: calc(var(--grid-column) * 6);

            @media (--viewport-tablet) {
                width: calc(var(--grid-column-mobile) * 12);
            }
        }

        &-description {
            width: calc(var(--grid-column) * 8);
            margin-left: calc(var(--grid-column) * 2);
            font-family: var(--font-accent);
            font-weight: 800;
            font-size: 20px;
            line-height: 1.2;
            color: #000000;
            padding-top: 40px;
            position: relative;

            @media (--viewport-tablet) {
                width: calc(var(--grid-column-mobile) * 10);
                margin-left: var(--grid-column-mobile);
                padding-top: 20px;
                margin-top: 20px;
            }

            @media (--viewport-mobile-s), (--viewport-mobile-lp) {
                font-size: 14px;
                padding: 0.7rem 0;
                margin-top: 0.7rem;
            }

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                background-color: #000;
                height: 3px;
                width: 15px;
            }
        }
    }
}

$city-transit: 0.6s;
$info-transit-transform: 0.7s;
$info-transit-opacity: 0.1s;
$image-transit: 0.5s;
$timing-func: cubic-bezier(0.645, 0.045, 0.355, 1);

.timeline {
    &__item {
        &.hidden {
            .timeline {
                &__item-info {
                    transform: translateX(200px);
                    opacity: 0;
                }
                &__item-image-wrapper {
                    &::before {
                        transform: scaleX(1);
                    }
                }
            }
            &:nth-child(2n) {
                .timeline__item-city {
                    span {
                        transform: translateY(-103%);
                        transform-origin: top center;
                    }
                }
            }
            &:nth-child(2n + 1) {
                .timeline__item-city {
                    span {
                        transform: translateY(103%);
                        transform-origin: bottom center;
                    }
                }
            }
        }
    }

    &__item {
        &-info {
            transition: transform $info-transit-transform $timing-func, opacity $info-transit-opacity $timing-func;
            transform: translateX(0px);
            opacity: 1;
        }

        &-city {
            overflow-y: hidden;
            width: auto;

            span {
                transition: transform $city-transit $timing-func;
                transform: translateY(0);
            }

            @media (--viewport-tablet) {
                width: calc(var(--grid-column-mobile) * 11);
                overflow-y: visible;
            }
        }

        &-image-wrapper {
            &::before {
                transition: transform $image-transit $timing-func;
                transform-origin: 0% 0%;
                transform: scaleX(0);
            }
        }
    }
}

@for $i from 0 through 3 {
    .timeline__item:nth-child(#{$i + 1}) {
        .timeline {
            &__item-info {
                transition-delay: ($i * ($info-transit-transform - 0.2));
            }
            &__item-image-wrapper {
                &::before {
                    transition-delay: ($i * $info-transit-transform + 0.2);
                }
            }
            &__item-city span {
                transition-delay: ($i * $info-transit-transform + 0.2 + $image-transit);
            }
        }
    }
}
</style>
